import React from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

export var LinkTable = React.createClass({
    render: function(){
        let attrs, attrMap;
        [attrs, attrMap ]= linkAttr(this.props.links);
        let data = prepData(this.props.links, attrs, attrMap);
        let headings = linkHeadings(attrs);
        let columns = [];
        for (let i = 0; i < attrs.length; i++) { //TODO: The width setting isn't working...
            columns.push(<TableHeaderColumn dataField={attrs[i]} key={attrs[i]} dataSort={true}
                                            dataFormat={cellFormater}width={colSize(attrs[i])}>
                {headings[i]}
                </TableHeaderColumn>);
        }

        return (<BootstrapTable data={data} striped={true}  keyField="id"
                                condensed={true}
                                height={this.props.height.toString()}>
        {columns}
      </BootstrapTable>);
    }
});

function cellFormater(cell, row) {
    if (typeof cell === 'number') {
        return cell.toPrecision(4);
    } else {
        return cell;
    }
}

/*
 Extracts the link attributes in addition to source, target, weight, and capacity.
 */
function linkAttr(links) {
    let linkAttr = ["source", "target", "weight", "capacity"];
    let attrMap = new Map();  // Set up a map to take us from attribute to formating type.
    attrMap.set("source", "string");
    attrMap.set("target", "string");
    attrMap.set("weight", "number");
    attrMap.set("capacity", "number");
    attrMap.set("ports", "ports");  // special processing given to port object.
    // Get all the link attributes used on nodes other than source, target, weight, and capacity
    let link, attr;
    for (let i = 0; i < links.length; i++) {
        link = links[i];
        for (attr in link) {
            if (link.hasOwnProperty(attr)) {
                if (linkAttr.indexOf(attr) === -1) { // not already in the attribute list
                    linkAttr.push(attr);
                    if (!attrMap.has(attr)) {
                        attrMap.set(attr, typeof link[attr]);
                    }
                }
            }
        }
    }
    return [linkAttr, attrMap];
}

function linkHeadings(linkAttr) {
    return linkAttr.map(capitalize);
}

function capitalize(s) {
    return s && s[0].toUpperCase() + s.slice(1);
}

function prepData(links, attrs, attrMap) {
    let data = links.map(function (l) {
            let linkData = {id: l.source + "-" + l.target};
            for (let attr of attrs) {
                if (!l[attr]) {
                    linkData[attr] = null;
                    continue;
                }
                switch (attrMap.get(attr)) {
                    case 'object':
                        linkData[attr] = JSON.stringify(l[attr]);
                        break;
                    case 'ports':
                        linkData[attr] = l.source + ": " + l.ports[l.source] + ", " +
                    l.target + ": " + l.ports[l.target];
                        break;
                    case 'number':
                    case 'string':
                    default:
                        linkData[attr] = l[attr];
                }

            }
            return linkData;
        }
    );
    return data;
}

function colSize(attr) {
    switch (attr) {
        case "source":
            return "60";
        case "target":
            return "60";
        case  "capacity":
            return "70";
        case "weight":
            return "70";
        case "ports":
            return "80";
        default:
            return "80";
    }
}


// WEBPACK FOOTER //
// ./src/info/LinkTable.js